import React from 'react';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-charcoal pt-20 pb-10" data-id="element-35">
      <div className="container mx-auto px-4 md:px-6" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16" data-id="element-37">
          <div data-id="element-38">
            <h3 className="text-2xl font-bold mb-6 text-white" data-id="element-39">Kivarro</h3>
            <p className="text-white/80 mb-6 text-lg" data-id="element-40">
              Accredited compliance training, workplace skills, and business
              courses across Ireland, the UK, and Europe.
            </p>
            <div className="flex space-x-4" data-id="element-41">
              <a href="https://facebook.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-42">
                <FacebookIcon size={20} data-id="element-43" />
              </a>
              <a href="https://twitter.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-44">
                <TwitterIcon size={20} data-id="element-45" />
              </a>
              <a href="https://linkedin.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-46">
                <LinkedinIcon size={20} data-id="element-47" />
              </a>
              <a href="https://instagram.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-48">
                <InstagramIcon size={20} data-id="element-49" />
              </a>
            </div>
          </div>
          <div data-id="element-50">
            <h4 className="text-xl font-semibold mb-6 text-white" data-id="element-51">Training</h4>
            <ul className="space-y-4" data-id="element-52">
              <li data-id="element-53">
                <a href="/compliance" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-54">
                  Compliance Training
                </a>
              </li>
              <li data-id="element-55">
                <a href="/workplace" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-56">
                  Workplace & HR
                </a>
              </li>
              <li data-id="element-57">
                <a href="/business" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-58">
                  Business Skills
                </a>
              </li>
              <li data-id="element-59">
                <a href="/programs" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-60">
                  Compliance Programs
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-61">
            <h4 className="text-xl font-semibold mb-6 text-white" data-id="element-62">Resources</h4>
            <ul className="space-y-4" data-id="element-63">
              <li data-id="element-64">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-65">
                  Free Checklists
                </a>
              </li>
              <li data-id="element-66">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-67">
                  Compliance Trackers
                </a>
              </li>
              <li data-id="element-68">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-69">
                  Audit Templates
                </a>
              </li>
              <li data-id="element-70">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-71">
                  Premium Bundles
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-72">
            <h4 className="text-xl font-semibold mb-6 text-white" data-id="element-73">Contact</h4>
            <ul className="space-y-4" data-id="element-74">
              <li data-id="element-75">
                <a href="/contact" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-76">
                  Contact Us
                </a>
              </li>
              <li data-id="element-77">
                <a href="/support" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-78">
                  Support
                </a>
              </li>
              <li data-id="element-79">
                <a href="/faq" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-80">
                  FAQs
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-10 mb-10 border-t border-b border-white/10 py-10" data-id="element-81">
          <div className="text-white/40 font-medium" data-id="element-82">CPD Certified</div>
          <div className="text-white/40 font-medium" data-id="element-83">ROSPA Approved</div>
          <div className="text-white/40 font-medium" data-id="element-84">
            Irish Trade Federation
          </div>
        </div>
        <div className="pt-6" data-id="element-85">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-86">
            <p className="text-white/50 text-sm mb-4 md:mb-0" data-id="element-87">
              &copy; {new Date().getFullYear()} Kivarro. All rights reserved.
            </p>
            <div className="flex space-x-8" data-id="element-88">
              <a href="/terms" className="text-white/50 hover:text-teal text-sm transition-colors" data-id="element-89">
                Terms
              </a>
              <a href="/privacy" className="text-white/50 hover:text-teal text-sm transition-colors" data-id="element-90">
                Privacy
              </a>
              <a href="/cookies" className="text-white/50 hover:text-teal text-sm transition-colors" data-id="element-91">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};